import { Configurations, HelloProduct } from "../types/backend";

const PROD_URL = "https://api.helloviewer.io";
const DEV_URL = "https://dev.api.helloviewer.io";

export class API {
  private static baseURL?: string;

  static setEnvironment = (server: "DEV" | "PROD") => {
    server === "DEV" ? (API.baseURL = DEV_URL) : (API.baseURL = PROD_URL);
  };

  fetchProduct = async (productId: string): Promise<HelloProduct> => {
    if (!API.baseURL) {
      throw "Environment not provided";
    }
    const embeddedJSON = { application: 1 };
    const urlEncodedEmbedQuery = encodeURIComponent(
      JSON.stringify(embeddedJSON)
    );
    const url = `${API.baseURL}/application_products/${productId}?embedded=${urlEncodedEmbedQuery}`;
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error("Error while fetching the product");
      }
      const data = await response.json();
      return data as HelloProduct;
    } catch (err) {
      throw err;
    }
  };

  fetchConfigurations = async (applicationId: string): Promise<Configurations> => {
    if (!API.baseURL) {
      throw "Environment not provided";
    }
    const whereJSON = { application: applicationId };
    const urlEncodedWhereQuery = encodeURIComponent(JSON.stringify(whereJSON));
    const url = `${API.baseURL}/application_configuration?where=${urlEncodedWhereQuery}`;
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error("Error while fetching the product");
      }
      const data = await response.json();
      return data as Configurations;
    } catch (err) {
      throw err;
    }
  };
}
